import { httpClient } from "../http-client";
import { Lottery } from "@/transactions/shared/models/lottery";
import { BetDates } from "@sazka/lotteries/js/models/draw-info/future-draw-dto";
import { PopupBannersJackpots } from "../models/banners-jackpots";

export async function getJackpotsForPopupBanners(): Promise<PopupBannersJackpots> {
    const response = await httpClient.get<PopupBannersJackpots>(`/draw-info/jackpots?lots=sportka&lots=eurojackpot`);

    return response.data;
}

export async function fetchFutureDraws(lottery: Lottery): Promise<BetDates> {
    const datesResponse = await httpClient.get<BetDates>(`/draw-info/future-draws/bet/${lottery}`);
    return datesResponse.data;
}
